import React from "react"
import StarsStyles from "./stars.module.css"

interface StarsProps {
    rating: number
}

const Stars = ({ rating }: StarsProps) => {
    return (
        <div className={StarsStyles.wrapper}>
            {[...Array(Math.floor(rating))].map((_, i) => (
                <div
                    className={StarsStyles.star}
                    key={i}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.623 0 8.115 7.637 0 7.64l6.566 4.72L4.06 20l6.562-4.72L17.191 20l-2.507-7.64 6.566-4.72-8.115-.003L10.623 0Z"
                            fill="#fcc943"
                        />
                    </svg>
                </div>
            ))}
            {rating !== 5 && (
                <div
                    className={StarsStyles.star}
                >
                    <div className={StarsStyles.emptyStar}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.623 0 8.115 7.637 0 7.64l6.566 4.72L4.06 20l6.562-4.72L17.191 20l-2.507-7.64 6.566-4.72-8.115-.003L10.623 0Z"
                                fill="#CCC"
                            />
                        </svg>
                    </div>
                    <div className={StarsStyles.filledStar} style={{ width: (rating % 1) * 100 + "%" }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 22 20"
                            className={StarsStyles.filledStarSvg}
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.623 0 8.115 7.637 0 7.64l6.566 4.72L4.06 20l6.562-4.72L17.191 20l-2.507-7.64 6.566-4.72-8.115-.003L10.623 0Z"
                                fill="#fcc943"
                            />
                        </svg>
                    </div>
                </div>
            )}
            {[...Array(5 - Math.floor(rating) - 1)].map((_, i) => (
                <div
                    className={StarsStyles.star}
                    key={i}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.623 0 8.115 7.637 0 7.64l6.566 4.72L4.06 20l6.562-4.72L17.191 20l-2.507-7.64 6.566-4.72-8.115-.003L10.623 0Z"
                            fill="#CCC"
                        />
                    </svg>
                </div>
            ))}
        </div>
    )
}

export default Stars
